import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import {
    AlertController,
    LoadingController,
    ModalController,
    NavController,
    Platform,
    ToastController
} from '@ionic/angular';

import { adjustViewZIndex, getDistanceInKM } from 'src/globals';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { ClubInfo } from 'src/data/club-course';
import { Locations } from 'src/data/country-location';
import { PlayerService } from 'src/providers/player-service/player-service';
import { GeolocationService } from 'src/providers/geolocation-service/geolocation-service';
import { EventObserver } from 'src/providers/event-service';
import { AddLocationPage } from '../add-location/add-location.page';
import { ClubListPage } from '../normalgame/club-list/club-list.page';
import { NavigationExtras, Router } from '@angular/router';
import { Location } from '@angular/common';
import { DeleteRoomModalComponent } from '../package-details/package-booking/delete-room-modal/delete-room-modal.component';

@Component({
    selector: 'app-player-favourite-list',
    templateUrl: './player-favourite-list.page.html',
    styleUrls: ['./player-favourite-list.page.scss'],
})
export class PlayerFavouriteListPage implements OnInit {      
    @Input() isFromModal:boolean;
    public favourites: Array<ClubInfo> = [];
    public locations: Array<Locations> = [];
    public clubIds: Array<number> = [];
    navigationExtras: NavigationExtras = {};
    dataExtras: any;
    constructor(
        private nav: NavController,
        private router: Router,
        private renderer: Renderer2,
        private playerService: PlayerService,
        private geo: GeolocationService,
        private modalCtl: ModalController,
        private alertCtl: AlertController,
        private toastCtl: ToastController,
        private platform: Platform,
        private loadingCtl: LoadingController,
        private globalEventObserver: EventObserver,
        private location: Location
    ) {
        this.globalEventObserver.getObservable().subscribe((data) => {
            if (data.chanel == "FavouriteListUpdate") {
                this._refreshFavourites();
            }
        })


    }

    ngOnInit() {
        this._refreshFavourites();
    }
    private async _refreshFavourites() {
        let loader: any = await this.loadingCtl.create({
            message: "Refreshing favorites..."
        });

        await loader.present().then(() => {
            this.playerService.getFavoriteClubs(false)
                .subscribe((favourites: Array<ClubInfo>) => {
                    this.playerService.getFavoriteLocations()
                        .subscribe((locations: Array<Locations>) => {
                            loader.dismiss().then(() => {
                                this.favourites = favourites;
                                this.clubIds = [];
                                favourites.forEach((m: ClubInfo) => {
                                    this.clubIds.push(m.clubId);
                                });
                                console.log('this.favourites: ', this.favourites);

                                if(this.favourites && this.favourites.length > 0)
                                    this.favourites.sort((a: ClubInfo,b: ClubInfo)=>{
                                        if(a.clubName.toLowerCase() < b.clubName.toLowerCase()) return -1;
                                        else if(a.clubName.toLowerCase() > b.clubName.toLowerCase()) return 1;
                                        else return 0
                                    })

                                this.locations = locations;
                            });
                        }, (error) => {
                            loader.dismiss();
                            let msg = MessageDisplayUtil.getErrorMessage(error);
                            MessageDisplayUtil.displayErrorAlert(this.alertCtl, "Favourites",
                                msg, "OK");
                        });
                }, (error) => {
                    loader.dismiss();
                    let msg = MessageDisplayUtil.getErrorMessage(error);
                    MessageDisplayUtil.displayErrorAlert(this.alertCtl, "Favourites",
                        msg, "OK");
                });
        })

    }

    /**
     * Gets the distance between a current location and club in KMs
     * @param club The club information
     * @returns {number} Returns the distance in KM if GPS locations of current and club are available
     * else returns 0;
     */
    clubDistance(club: ClubInfo): string {
        let lat1 = this.geo.getLatitude();
        let lon1 = this.geo.getLongitude();
        if (lat1 != null && lon1 != null && club.latitude != null && club.longitude != null)
            return getDistanceInKM(lat1, lon1, club.latitude, club.longitude) + " KM";
        return "";
    }

    onRefreshFavorite() {
        this._refreshFavourites();
    }

    addClubFavourite() {

    }

    async openClubFavourite() {
        const modal: any = await this.modalCtl.create(
            {
                component: ClubListPage,
                cssClass:'ion-infinite-scroll',
                mode:'ios',
                componentProps: {
                    openedModal: true
                }
            });
        modal.onDidDismiss().then((data: ClubInfo) => {
            if (data) {
                this.addFavoriteClubProcess(data);
            }
        });
        modal.present();
    }

    private async addFavoriteClubProcess(club: any) {
        let loader: any = await this.loadingCtl.create({
            showBackdrop: false,
            duration: 5000,
            message: 'Adding favourite club...'
        });

        await loader.present().then(() => {
            if (club.data) {
                this.playerService.addFavoriteClub(club.data.clubId)
                    .subscribe(() => {
                        loader.dismiss().then(() => {
                            this._refreshFavourites();
                        })

                    }, (error) => {
                        loader.dismiss();
                    })
            }
        })
    }

    async openLocFavourite() {
        //this.nav.push(AddLocationPage);
        const modal: any = await this.modalCtl.create(
            {
                component: AddLocationPage,
                componentProps: {
                    openedModal: true
                }
            });

        modal.onDidDismiss((data: ClubInfo) => {
            this._refreshFavourites();
        })
        // modal.onDismiss((data: ClubInfo)=> {
        //  if (data) {
        //  this.addFavoriteClubProcess(data);
        //  }
        //  });
        modal.present();

    }

    async deleteFavouriteClubConfirm(favourite: ClubInfo) {
        // let confirm: any = await this.alertCtl.create({
        //     header: "Delete Favourite",
        //     message: "Do you want to delete your Favourite Club?",
        //     buttons: [
        //         {
        //             text: 'No',
        //             role: "cancel",

        //             handler: () => {
        //                 confirm.dismiss();
        //                 return false;
        //             }
        //         },
        //         {
        //             text: 'Delete',
        //             cssClass: 'delete-item',
        //             role: "delete",
        //             handler: () => {
        //                 confirm.dismiss()
        //                     .then(() => {
        //                         this._deleteClubFavourite(favourite);
        //                     });
        //                 return false;
        //             }
        //         }

        //     ]
        // });
        // confirm.present();
        
        // Modal into modal open
        if(this.isFromModal){
            const modal = await this.modalCtl.create({
                component:DeleteRoomModalComponent,
                cssClass: this.platform.is('mobile') ? 'self-favorite-adjustable-modal' : 'self-adjustable-modal-desktop',
                componentProps:{
                    mode:'fromBooking'
                },
                showBackdrop:true,
                mode:'ios'
            })
            modal.present();
            modal.onDidDismiss().then((data)=>{
                if(data){
                  if(data?.data === 'confirm'){   
                    this._deleteClubFavourite(favourite);
                  }
                }
            })
        } // From Routing to Open Modal
        else{
            const modal = await this.modalCtl.create({
                component:DeleteRoomModalComponent,
                cssClass: this.platform.is('mobile') ? 'self-adjustable-modal' : 'self-adjustable-modal-desktop',
                componentProps:{
                    mode:'fromBooking'
                },
                showBackdrop:true,
                mode:'ios'
            })
            modal.present();
            modal.onDidDismiss().then((data)=>{
                if(data){
                  if(data?.data === 'confirm'){    
                    this._deleteClubFavourite(favourite);
                  }
                }
            })
        }
        
    }

    private async _deleteClubFavourite(favourite: ClubInfo) {
        let busy: any = await this.loadingCtl.create({
            message: "Deleting favourite club..."
        });
        await busy.present().then(() => {
            this.playerService.deleteFavoriteClub(favourite.clubId)
                .subscribe(() => {
                    busy.dismiss().then(() => {
                        this._refreshFavourites();
                    })

                }, (error) => {
                    busy.dismiss().then(() => {
                        let msg = MessageDisplayUtil.getErrorMessage(error, "Error deleting favourite club.");
                        MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 3000, "bottom");
                    })
                });
        })

    }

    async deleteFavouriteLocationConfirm(locations: Locations) {
        let confirm: any = this.alertCtl.create({
            header: "Delete Favourite",
            message: "Do you want to delete your Favourite Location?",
            buttons: [
                {
                    text: 'No',
                    role: "cancel",

                    handler: () => {
                        confirm.dismiss();
                        return false;
                    }
                },
                {
                    text: 'Delete',
                    cssClass: 'delete-item',
                    role: "delete",
                    handler: () => {
                        confirm.dismiss()
                            .then(() => {
                                this._deleteLocationFavourite(locations);
                            });
                        return false;
                    }
                }

            ]
        });
        confirm.present();
    }

    private _deleteLocationFavourite(location: Locations) {
        this.playerService.deleteFavoriteLocation(location.countryId, location.state, location.city)
            .subscribe(() => {
                this._refreshFavourites();
            });
    }

    backnavigate() {
        // this.navigationExtras.state = {
        //     userType: 'player'
        //   }
        //   this.router.navigate(['/tabs/booking-home'], this.navigationExtras);
        if(this.isFromModal){
            this.modalCtl.dismiss();
        }else{
            this.location.back()
        } 
    }

}
